import { createHobbitEngineApp } from 'hobbit-vip-engine';
import { StudentClientUser } from 'hobbit-vip-engine/modules/user';
import { defaultBeforeSend } from 'hobbit-vip/modules/ems';
import 'hobbit-vip-engine/styles/default-font-face.less'; // 默认字体定义样式（可选）

const env = import.meta.env.MODE;

import(`./config/${env}.js`).then(async chunk => {
  const config = chunk.default;

  await createHobbitEngineApp({
    config,
    env,
    onRouterReady: (router) => {
      // #region 初始化用户模块
      $H.user = new StudentClientUser();
      // #endregion

      // #region 扩展自定义数据上报字段
      $H.ems.beforeSend = (params, category, channel) => {
        params.user_id = $H.user.userId() ?? '';
        params.login_status = $H.user.isLogin(false) ? 1 : 0;
        if (!params.custom) params.custom = {};
        params.custom.student_id = $H.user.studentId() ?? '';
        params.custom.parent_id = $H.user.parentId() ?? '';
        params = defaultBeforeSend(params, category, channel);
        return params;
      };
      // #endregion
    },
    onInstallPage: null,
    onBeforeAppMount: null,
    rawRoutes: null,
  });
});
